import { makeAutoObservable } from 'mobx'
import { ChatbotBookingType, type IBookingType, type IChatbotSettings } from '../type'

export class ChatbotBooking {
  bookingEnabled = false
  type: IBookingType = ChatbotBookingType.TimeChat
  link: IChatbotSettings['book_appointment_link'] = null
  smartBookingEnabled = true

  constructor() {
    makeAutoObservable(this)
  }

  setEnabled = (value: boolean) => {
    this.bookingEnabled = value

    if (!value) {
      this.link = null
      this.smartBookingEnabled = true
      this.type = ChatbotBookingType.TimeChat
    }
  }

  setType = (type: IBookingType) => {
    this.type = type
  }

  setLink = (link: IChatbotSettings['book_appointment_link']) => {
    this.link = link
  }

  setSmartBookingEnabled = (value: boolean) => {
    this.smartBookingEnabled = value
  }

  syncOrigin(settings?: IChatbotSettings | null) {
    this.bookingEnabled = settings?.book_appointment_enabled?.value ?? false
    this.type = settings?.book_appointment_type?.value ?? ChatbotBookingType.TimeChat
    this.link = settings?.book_appointment_link ?? null
    this.smartBookingEnabled = settings?.smart_booking_enabled?.value ?? true
  }

  toJSON(): Pick<
    IChatbotSettings,
    | 'book_appointment_enabled'
    | 'book_appointment_type'
    | 'book_appointment_link'
    | 'smart_booking_enabled'
  > {
    return {
      book_appointment_enabled: { value: this.bookingEnabled },
      book_appointment_type: { value: this.type },
      book_appointment_link: this.link,
      smart_booking_enabled: { value: this.smartBookingEnabled },
    }
  }
}
